import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-primary border-t border-border py-6 mt-auto">
    <div className="container mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-3 font-mono text-xs text-muted-foreground">
      <span><span>BRACKET</span> <span className="text-gradient">RUN</span> — Beta 2026</span>
      <Link to="/tip-jar" className="hover:text-foreground transition-colors">☕ תמכו בנו</Link>
    </div>
  </footer>
);

export default Footer;
